import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbModule, NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {InViewportModule} from 'ng-in-viewport';
import {DashboardComponent} from '@components/dashboard/dashboard.component';
import {MachineComponent} from '@components/dashboard/tiles/machine-tile-item/machine.component';
import {GroupComponent} from '@components/dashboard/groups/group.component';
import {GroupItemComponent} from '@components/dashboard/groups/group-item/group-item.component';
import {MachineLayoutComponent} from '@components/dashboard/tiles/machine-layout/machine-layout.component';
import {SharedModule} from '@shared/shared.module';
import {DashboardRoutingModule} from '@components/dashboard/dashboard-routing.module';
import {MachineMapComponent} from './map/machine-map.component';
import {GoogleMapsModule} from '@angular/google-maps';
import {
  MachineTileContainerComponent
} from '@components/dashboard/tiles/machine-tile-container/machine-tile-container.component';
import {
  MachineListContainerComponent
} from '@components/dashboard/list/machine-list-container/machine-list-container.component';
import {
  MachineListCategoryContainerComponent
} from '@components/dashboard/list/machine-list-category-container/machine-list-category-container.component';
import {NgxPaginationModule} from 'ngx-pagination';
import {DashboardLocationsComponent} from '@components/dashboard/dashboard-locations/dashboard-locations.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';

@NgModule({
  declarations: [
    DashboardComponent,
    MachineComponent,
    GroupComponent,
    GroupItemComponent,
    MachineLayoutComponent,
    MachineMapComponent,
    MachineTileContainerComponent,
    MachineListContainerComponent,
    MachineListCategoryContainerComponent,
    DashboardLocationsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgbModule,
    NgSelectModule,
    InfiniteScrollModule,
    TranslateModule,
    FormsModule,
    //in view component
    InViewportModule,
    GoogleMapsModule,
    NgxPaginationModule,
    DashboardRoutingModule,
    NgbPopoverModule
  ]
})
export class DashboardModule {
}
